var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"outcomeWrap",class:['m-outcome', _vm.changeType, {
    'active': _vm.active && !_vm.isDisabled,
    'disabled': _vm.isDisabled,
    'm-outcome--up': _vm.isUp,
    'm-outcome--down': _vm.isDown,
    'multiple': _vm.showDesc,
    'in-oddsRange': _vm.inOddsRange,
    'odds-disabled': (_vm.isLoading || _vm.isConflict) && !_vm.isDisabled && !_vm.active
  }],on:{"click":function($event){$event.stopPropagation();return _vm.toogleSelected.apply(null, arguments)}}},[_c('keep-alive',[(!_vm.isDisabled && (_vm.isUp || _vm.isDown))?_c('i',{class:['m-icon-arrow', {
        'up': _vm.isUp,
        'down': _vm.isDown
      }]}):_vm._e()]),_vm._v(" "),(_vm.showDesc)?_c('div',{staticClass:"desc"},[_vm._v("\n    "+_vm._s(_vm.description || _vm.outcome.description)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.isDisabled)?_c('img',{attrs:{"width":"19px","src":require("public/images/icon/locked.svg"),"alt":"disabled"}}):_c('div',{staticClass:"odds"},[_vm._v("\n    "+_vm._s(_vm.outcome.odds)+"\n    "),(_vm.isLoading)?_c('div',{staticClass:"odds-loading",style:({ '--time': _vm.moveTime })}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }